import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalService } from "@azure/msal-angular";
import { AppConfigService } from "../core/services/app-config.service";
import { MSALInstanceFactory } from "../core/factories/msal-instance.factory";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MSALGuardConfigFactory } from "../core/factories/msal-guard-config.factory";
import { MSALInterceptorConfigFactory } from "../core/factories/msal-interceptor-config.factory";

@NgModule({
    providers: [],
    imports: [MsalModule]
})
export class MsalConfigModule {
    // Static method to configure the module
    static forRoot() {
        return {
            ngModule: MsalConfigModule,
            providers: [
                // Provide the MSAL_INSTANCE using a factory and AppConfigService dependency
                {
                    provide: MSAL_INSTANCE,
                    useFactory: MSALInstanceFactory,
                    deps: [AppConfigService]
                },
                // Provide the MSAL_GUARD_CONFIG using a factory and AppConfigService dependency
                {
                    provide: MSAL_GUARD_CONFIG,
                    useFactory: MSALGuardConfigFactory,
                    deps: [AppConfigService]
                },
                // Provide the MSAL_INTERCEPTOR_CONFIG using a factory and AppConfigService dependency
                {
                    provide: MSAL_INTERCEPTOR_CONFIG,
                    useFactory: MSALInterceptorConfigFactory,
                    deps: [AppConfigService]
                },
                // Provide the MsalService
                MsalService,
                // Provide the MsalGuard
                MsalGuard,
                // Provide the MsalBroadcastService
                MsalBroadcastService,
                // Use the MsalInterceptor as an HTTP interceptor
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: MsalInterceptor,
                    multi: true
                }
            ]
        };
    }
}